import { c as _c } from "react/compiler-runtime";
import { getErrorMessage, useRequestError } from '@onefootprint/request';
import { useEffect } from 'react';
import { ConfigRequestFailureReason } from '../../../src/utils/state-machine/types';
import { InitShimmer } from '../../components';
import type { DeviceInfo } from '../../hooks';
import { useDeviceInfo, useIdvMachine } from '../../hooks';
import { useGetOnboardingConfig } from '../../queries';
import { getLogger, trackAction } from '../../utils';
const {
  logError,
  logWarn
} = getLogger({
  location: 'idv-init'
});
const Init = () => {
  const $ = _c(21);
  const [state, send] = useIdvMachine();
  const {
    getErrorCode,
    getErrorStatusCode
  } = useRequestError();
  const {
    obConfigAuth,
    authToken,
    device,
    bootstrapData: t0
  } = state.context;
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const bootstrapData = t1;
  let t2;
  if ($[2] !== device || $[3] !== send) {
    t2 = info => send({
      type: "initContextUpdated",
      payload: {
        device: device ?? info
      }
    });
    $[2] = device;
    $[3] = send;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useDeviceInfo(t2, _temp);
  let t3;
  if ($[5] !== bootstrapData) {
    t3 = () => {
      const populatedBootstrapKeys = Object.entries(bootstrapData).filter(_temp2).map(_temp3);
      trackAction("onboarding:started", {
        hasBootstrapData: populatedBootstrapKeys.length > 0,
        populatedBootstrapKeys
      });
    };
    $[5] = bootstrapData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== authToken || $[9] !== obConfigAuth) {
    t5 = {
      obConfigAuth,
      authToken
    };
    $[8] = authToken;
    $[9] = obConfigAuth;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== send) {
    t6 = config => {
      send({
        type: "initContextUpdated",
        payload: {
          config
        }
      });
    };
    $[11] = send;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== getErrorCode || $[14] !== getErrorStatusCode || $[15] !== send) {
    t7 = error => {
      const errorCode = getErrorCode(error);
      const errorStatusCode = getErrorStatusCode(error);
      trackAction("onboarding:started-failed", {
        error: getErrorMessage(error)
      });
      logError(`Fetching onboarding config in IDV init page failed errorCode:${errorCode}, errorStatusCode:${errorStatusCode}`, error);
      let reason = ConfigRequestFailureReason.other;
      if (errorCode === "E118") {
        reason = ConfigRequestFailureReason.sessionExpired;
      } else {
        if (errorStatusCode === 404) {
          reason = ConfigRequestFailureReason.invalidConfig;
        }
      }
      send({
        type: "configRequestFailed",
        payload: {
          reason
        }
      });
    };
    $[13] = getErrorCode;
    $[14] = getErrorStatusCode;
    $[15] = send;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = {
      onSuccess: t6,
      onError: t7
    };
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  useGetOnboardingConfig(t5, t8);
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <InitShimmer />;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
export default Init;
function _temp() {
  return logWarn("Unable to collect device info");
}
function _temp2(t0) {
  const [, value] = t0;
  return Array.isArray(value) ? value.length > 0 : !!value;
}
function _temp3(t0) {
  const [key] = t0;
  return key;
}